angular.module('ApiUtils.ksat', [
]);
